import { createSelector } from '@reduxjs/toolkit';
import { createApi } from '@reduxjs/toolkit/query/react';
import { ProjectStateReason } from './models';
import { baseApi } from '@centerpiece/components';

export const project_state_reason = baseApi
  .enhanceEndpoints({
    addTagTypes: ['ProjectStateReasons', 'ProjectStateReason'],
  })
  .injectEndpoints({
    endpoints: builder => ({
      getProjectStateReasons: builder.query<
        ProjectStateReason[],
        { params?: object }
      >({
        query: ({ params }: { params?: object }) => ({
          url: 'project_state_reason',
          method: 'GET',
          params: params,
        }),
        providesTags: (result, error, arg) =>
          result
            ? [
                ...result.map(({ id }) => ({
                  type: 'ProjectStateReason' as const,
                  id,
                })),
                'ProjectStateReasons',
              ]
            : ['ProjectStateReasons'],
      }),
      getProjectStateReason: builder.query<ProjectStateReason, string>({
        query: id => ({
          url: `project_state_reason/${id}`,
          method: 'GET',
        }),
        providesTags: (result, error, arg) => [
          { type: 'ProjectStateReason', id: arg },
        ],
        // configuration for an individual endpoint, overriding the api setting
        keepUnusedDataFor: 90,
      }),
      createProjectStateReason: builder.mutation({
        query: request => ({
          url: 'project_state_reason',
          method: 'POST',
          body: request,
        }),
        invalidatesTags: ['ProjectStateReasons'],
      }),
      updateProjectStateReason: builder.mutation<
        ProjectStateReason,
        ProjectStateReason
      >({
        query: request => ({
          url: `project_state_reason/${request.id}`,
          method: 'PUT',
          body: request,
        }),
        invalidatesTags: (result, error, arg) => [
          { type: 'ProjectStateReason', id: arg.id },
        ],
      }),
      deleteProjectStateReason: builder.mutation<ProjectStateReason, number>({
        query: id => ({
          url: `project_state_reason/${id}`,
          method: 'DELETE',
        }),
        invalidatesTags: (result, error, arg) =>
          result
            ? [
                { type: 'ProjectStateReason' as const, arg },
                'ProjectStateReasons',
              ]
            : ['ProjectStateReasons'],
      }),
    }),
  });

// Auto-generated hooks
export const {
  useGetProjectStateReasonsQuery,
  useGetProjectStateReasonQuery,
  useCreateProjectStateReasonMutation,
  useUpdateProjectStateReasonMutation,
  useDeleteProjectStateReasonMutation,
  usePrefetch: useProjectStateReasonsPrefetch,
} = project_state_reason;
const selectProjectStateReasonsRoot =
  project_state_reason.endpoints.getProjectStateReasons.select({});
export const selectProjectStateReasons = createSelector(
  selectProjectStateReasonsRoot,
  project_state_reason => project_state_reason.data || []
);
